/**
 * Build the public business profile path for a service/search result item.
 *
 * Search APIs (conciergeSearch and /getService) return the slug at the
 * top level (`item.businessSlug`); service-details and favorites items nest
 * it under `item.business.businessSlug`. Backend slugs are stored with the
 * `@` prefix (e.g. `@james-peterson-services`), so we normalize defensively.
 *
 * @returns e.g. `/business/@james-peterson-services`, or null when no slug.
 */
export const getBusinessProfilePath = (item: any): string | null => {
  const raw = item?.businessSlug || item?.business?.businessSlug;
  if (!raw) return null;
  const slug = raw.startsWith('@') ? raw : `@${raw}`;
  return `/business/${slug}`;
};
